import { render, staticRenderFns } from "./doc_watch.vue?vue&type=template&id=4c1a3ea0&scoped=true&"
import script from "./doc_watch.vue?vue&type=script&lang=js&"
export * from "./doc_watch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a3ea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1a3ea0')) {
      api.createRecord('4c1a3ea0', component.options)
    } else {
      api.reload('4c1a3ea0', component.options)
    }
    module.hot.accept("./doc_watch.vue?vue&type=template&id=4c1a3ea0&scoped=true&", function () {
      api.rerender('4c1a3ea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/resolution/doc_watch/doc_watch.vue"
export default component.exports